const navCols = [
  { title: '栏目', links: [['实时速递', '#realtime'], ['今日热榜', '#hotlist'], ['分类栏目', '#column'], ['热门专题', '#column']] },
  { title: '关于', links: [['关于我们', '#about'], ['常见问题', '#faq'], ['订阅快讯', '#contact'], ['投稿合作', '#contact']] },
  { title: '速递', links: [['明星动态', '#column'], ['影视现场', '#column'], ['音乐乐坛', '#column'], ['时尚红毯', '#column']] },
];

export default function Footer() {
  return (
    <footer className="mt-16 md:mt-24 bg-accent-100 text-foreground-900">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-5">
          <div className="md:col-span-2">
            <a href="#home-top" className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center font-display text-lg">瓜</span>
              <span className="leading-none">
                <span className="block font-heading text-xl font-black text-foreground-950">最快吃瓜</span>
                <span className="block text-[11px] tracking-[0.18em] text-primary-600 mt-1">第一手 · 独家 · 秒级</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 max-w-sm">
              全网滚动追踪娱乐热点的吃瓜门户。把真实发生、正在被讨论的事，讲得清楚、及时、克制，让你永远快人一步。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/70 text-xs text-foreground-700">
                <i className="ri-verified-badge-line text-accent-700"></i>内容来源可溯
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/70 text-xs text-foreground-700">
                <i className="ri-radar-line text-primary-500"></i>24h 滚动更新
              </span>
            </div>
          </div>

          {navCols.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="text-sm font-black text-foreground-950 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    <a href={href} className="text-sm text-foreground-700 hover:text-primary-600 hover:underline transition">{label}</a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} 最快吃瓜 · 第一手消息 独家速递。本网站仅做资讯分享，请理性吃瓜。</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a href="mailto:editor@example.com" className="hover:text-primary-600 flex items-center gap-1.5 whitespace-nowrap"><i className="ri-mail-line"></i>editor@example.com</a>
            <span className="flex items-center gap-1.5"><i className="ri-timer-flash-line"></i>秒级更新</span>
          </div>
        </div>
      </div>
    </footer>
  );
}